import React from "react";
import { Tile } from "./primitives";

export default function EndpointUsagePanel({ usage }) {
  const entries = Object.entries(usage || {}).sort(
    (a, b) => (b[1].d30 || 0) - (a[1].d30 || 0)
  );
  return (
    <Tile title="Endpoint usage (30d)" testid="tile-endpoints">
      <div className="space-y-1.5">
        {entries.map(([ep, v]) => (
          <div key={ep} className="flex items-center justify-between text-xs">
            <span className="text-[#5C6B62] font-mono">{ep}</span>
            <span className="font-mono-num text-[#1C2B23]">
              {(v.d30 || 0).toLocaleString()}
            </span>
          </div>
        ))}
        {entries.length === 0 && (
          <div className="text-xs text-[#5C6B62]">No usage logged yet.</div>
        )}
      </div>
    </Tile>
  );
}
